import styled from 'styled-components/native';
import { MODAL_HORIZONTAL_PADDING } from '~/data/constants';

export const Container = styled.View``;

export const Content = styled.View`
  background-color: ${({ theme }) => theme.color.base.c0};
  padding-vertical: 24px;
  padding-horizontal: ${MODAL_HORIZONTAL_PADDING}px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
`;

export const Title = styled.Text`
  margin-bottom: 16px;
  text-align: center;
  font-family: ${({ theme }) => theme.fontFamily.core.w600};
  color: ${({ theme }) => theme.color.base.c10};
  font-size: 18px;
  line-height: 22px;
`;

export const WebContent = styled.View`
  padding: 16px;
  align-items: center;
`;
